// import React from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Paper,
//   Chip,
//   Button,
//   Divider,
//   Stack
// } from '@mui/material';

// // Exemple de fonction pour récupérer les détails d’un projet (à remplacer par un appel API réel)
// const getProjectByName = (name) => {
//   const dummyProjects = [
//     {
//       name: 'TERRACE EXTERIEURE',
//       client: 'Christian Ntopi',
//       status: 'En cours',
//       description: 'Aménagement extérieur d’une terrasse avec revêtement en bois et mobilier design.',
//       submittedAt: '2025-06-01',
//     },
//     {
//       name: 'SALLE DE REUNION',
//       client: 'Sophie Elenga',
//       status: 'Etudié',
//       description: 'Conception d’une salle de réunion moderne avec équipement audiovisuel.',
//       submittedAt: '2025-05-22',
//     },
//   ];

//   return dummyProjects.find((p) => p.name === decodeURIComponent(name));
// };

// // Style de couleur pour le statut
// const getStatusColor = (status) => {
//   switch (status) {
//     case 'En cours':
//       return 'info';
//     case 'Etudié':
//       return 'success';
//     case 'Rejeté':
//       return 'error';
//     default:
//       return 'default';
//   }
// };

// const BeProjectDetails = () => {
//   const { nom } = useParams();
//   const navigate = useNavigate();

//   const project = getProjectByName(nom);

//   if (!project) {
//     return (
//       <Box p={4}>
//         <Typography variant="h5">Projet non trouvé.</Typography>
//         <Button onClick={() => navigate(-1)} sx={{ mt: 2 }} variant="outlined">
//           Retour
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <>
//         <div className="content-body">
//             <div className="container-fluid">
//                 <Box p={4}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Typography variant="h4" gutterBottom>
//           {project.name}
//         </Typography>

//         <Divider sx={{ mb: 3 }} />

//         <Stack spacing={2}>
//           <Typography variant="body1">
//             <strong>Client :</strong> {project.client}
//           </Typography>

//           <Typography variant="body1">
//             <strong>Date de soumission :</strong> {new Date(project.submittedAt).toLocaleDateString()}
//           </Typography>

//           <Box>
//             <Typography variant="body1" sx={{ display: 'inline', mr: 1 }}>
//               <strong>État :</strong>
//             </Typography>
//             <Chip label={project.status} color={getStatusColor(project.status)} />
//           </Box>

//           <Box>
//             <Typography variant="body1" gutterBottom>
//               <strong>Description :</strong>
//             </Typography>
//             <Typography variant="body2">{project.description}</Typography>
//           </Box>
//         </Stack>

//         <Box mt={4}>
//           <Button variant="contained" color="primary" onClick={() => navigate('/be-projects')}>
//             Retour
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//             </div>
//         </div>
//     </>
//   );
// };

// export default BeProjectDetails;


import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Button,
  Divider,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';

const getProjectByName = (name) => {
  const dummyProjects = [
    {
      name: 'TERRACE EXTERIEURE',
      client: 'Christian Ntopi',
      status: 'En cours',
      type: 'Aménagement extérieur',
      budget: 25000,
      submittedAt: '2025-06-01',
      responsible: 'Sophie Elenga',
      description: 'Création d’une terrasse avec revêtement bois...',
      internalNotes: 'Attente validation du devis...',
      attachments: [
        { label: 'Plan', url: '/docs/terrasse-plan3d.pdf' },
        { label: 'Photos existant', url: '/images/terrasse-existant.jpg' },
      ],
    },
  ];

  return dummyProjects.find((p) => p.name === decodeURIComponent(name));
};

const getStatusColor = (status) => {
  switch (status) {
    case 'En cours':
      return 'info';
    case 'Etudié':
      return 'success';
    case 'Rejeté':
      return 'error';
    default:
      return 'default';
  }
};

const BeProjectDetails = () => {
  const { nom } = useParams();
  const navigate = useNavigate();
  const project = getProjectByName(nom);

  if (!project) {
    return (
      <Box p={4}>
        <Typography variant="h5">Projet non trouvé.</Typography>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }} variant="outlined">
          Retour
        </Button>
      </Box>
    );
  }

  return (
    <div className="content-body">
      <div className="container-fluid">
        <Box p={4}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
              {project.name}
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell><strong>Client</strong></TableCell>
                    <TableCell>{project.client}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Type de projet</strong></TableCell>
                    <TableCell>{project.type}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Responsable BE</strong></TableCell>
                    <TableCell>{project.responsible}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Statut</strong></TableCell>
                    <TableCell>
                      <Chip label={project.status} color={getStatusColor(project.status)} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Budget estimé</strong></TableCell>
                    <TableCell>{project.budget.toLocaleString()} €</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Date de soumission</strong></TableCell>
                    <TableCell>{new Date(project.submittedAt).toLocaleDateString()}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Description</strong></TableCell>
                    <TableCell>{project.description}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Commentaires internes</strong></TableCell>
                    <TableCell>
                      <em style={{ color: 'gray' }}>{project.internalNotes}</em>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Pièces jointes</strong></TableCell>
                    <TableCell>
                      {project.attachments.map((file, idx) => (
                        <Link
                          key={idx}
                          href={file.url}
                          target="_blank"
                          rel="noopener"
                          underline="hover"
                          sx={{ display: 'block' }}
                        >
                          📎 {file.label}
                        </Link>
                      ))}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box mt={4}>
              <Button variant="contained" onClick={() => navigate('/be-projects')}>
                ← Retour aux projets
              </Button>
            </Box>
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default BeProjectDetails;